"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SetColumnButton = void 0;
exports.useSetColumn = useSetColumn;
var _SettingLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/general/SettingLine.svg"));
var _CheckCircleFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/CheckCircleFill.svg"));
var _InfoCircleLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/InfoCircleLine.svg"));
var _button = _interopRequireDefault(require("../button"));
var _dropdown = _interopRequireDefault(require("../dropdown"));
var _icon = _interopRequireDefault(require("../icon"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsStorage = _interopRequireDefault(require("js-storage"));
var _react = _interopRequireWildcard(require("react"));
var _defineType = require("../_util/defineType");
var _useConfig = require("../hooks/useConfig");
var _table = require("./table");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const storage = _jsStorage.default.localStorage;
const SetColumnButton = props => {
  const {
    columnsConfig,
    setColumnsConfig,
    showResetColumnButton,
    ...buttonProps
  } = props;
  const {
    locale: {
      Table: TableLocale
    }
  } = (0, _useConfig.useConfig)();
  const [visible, setVisible] = (0, _react.useState)(false);
  const Overlay = (0, _react.useCallback)(() => {
    const [config, setConfig] = (0, _react.useState)(columnsConfig);
    const checkedNum = (0, _react.useMemo)(() => {
      return config.reduce((p, c) => {
        if (c.checked) {
          return p + 1;
        } else {
          return p;
        }
      }, 0);
    }, [config]);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "setTableColumnDropdown",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "group",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "".concat(TableLocale.setColumnDropdown_title, " (").concat(checkedNum, "/").concat(config.length, ")")
        }), showResetColumnButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          onClick: () => {
            _table.tableEmitter.emit('reset-table-size');
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tooltip.default, {
            className: "reset",
            title: TableLocale.resetColumnWidthTooltip,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: TableLocale.resetColumnWidth
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
              className: "icon",
              type: "suggest/InfoCircleLine"
            })]
          })
        }) : null]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "content",
        children: config === null || config === void 0 ? void 0 : config.map(item => {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnames.default)('item', {
              ['item-selected']: item.checked,
              ['item-disabled']: item.disabled
            }),
            onClick: () => {
              if (item.disabled) {
                return;
              }
              const newConfig = config.map(c => {
                if (c.key === item.key) {
                  return {
                    ...c,
                    checked: !c.checked
                  };
                } else {
                  return c;
                }
              });
              setConfig(newConfig);
            },
            children: [item.title, item.checked && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
              type: "suggest/CheckCircleFill",
              className: (0, _classnames.default)('checkIcon', {
                ['checkIcon-disabled']: item.disabled
              }),
              fontSize: 16
            })]
          }, item.key);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "actions",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
          size: "s",
          width: 111,
          onClick: () => {
            setVisible(false);
            setColumnsConfig(config.map(i => {
              const {
                title,
                ...v
              } = i;
              return v;
            }));
          },
          children: TableLocale.setColumnDropdown_confirm
        })
      })]
    });
  }, [visible]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdown.default, {
    open: visible,
    trigger: ['click'],
    destroyPopupOnHide: true,
    onOpenChange: visible => visible === false && setVisible(visible),
    getPopupContainer: triggerNode => triggerNode.parentNode,
    dropdownRender: () => /*#__PURE__*/(0, _jsxRuntime.jsx)(Overlay, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
      title: TableLocale.setColumnButtonTip,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
        type: "normal",
        size: "s",
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "general/SettingLine"
        }),
        onClick: () => {
          setVisible(!visible);
        },
        ...buttonProps
      })
    })
  });
};
exports.SetColumnButton = SetColumnButton;
function useSetColumn(props) {
  const {
    columns,
    id,
    userUid,
    version
  } = props;
  const _version = version.replace(/\./g, '_'); // 1.1.1的点会被浏览器吃了
  const storageKey = "__TABLECOLUMN_".concat(id, "_").concat(_version, "_").concat(userUid);
  const [operation, setOperation] = (0, _react.useState)({
    columnsConfig: storage.isEmpty(storageKey) ? columns.filter(i => !i.hidden).map(item => ({
      title: item.columnsOpts.title || item.title,
      //item.title 必须是string
      key: item.columnsOpts.key,
      disabled: item.columnsOpts.disabled,
      checked: item.columnsOpts.defaultChecked
    })) : columns.filter(i => !i.hidden).map(item => {
      const findColumn = storage.get(storageKey).find(i => item.columnsOpts.key === i.key);
      return {
        title: item.columnsOpts.title || item.title,
        key: item.columnsOpts.key,
        disabled: item.columnsOpts.disabled,
        checked: item.columnsOpts.defaultChecked,
        ...findColumn
      };
    }),
    setColumnsConfig(config) {
      const _columnsConfig = columns.map(item => {
        const findColumn = config.find(i => item.columnsOpts.key === i.key);
        return {
          title: item.columnsOpts.title || item.title,
          key: item.columnsOpts.key,
          disabled: item.columnsOpts.disabled,
          checked: item.columnsOpts.defaultChecked,
          ...findColumn
        };
      });
      storage.set(storageKey, _columnsConfig.map(i => {
        const {
          title,
          ...v
        } = i;
        return v;
      }));
      setOperation({
        ...operation,
        columnsConfig: _columnsConfig
      });
    }
  });
  const tableColumns = (0, _react.useMemo)(() => {
    return columns.filter(item => operation.columnsConfig.some(c => c.key === item.columnsOpts.key && c.checked)).map(item => {
      const {
        columnsOpts,
        exportOpts,
        ...other
      } = item;
      return other;
    });
  }, [columns, operation.columnsConfig]);
  const exportOpts = (0, _react.useMemo)(() => {
    return columns.reduce((p, r) => {
      if (r.exportOpts && !r.hidden) {
        if ((0, _defineType.isArray)(r.exportOpts)) {
          return [...p, ...r.exportOpts];
        } else {
          return [...p, r.exportOpts];
        }
      }
      return p;
    }, []);
  }, [columns]);
  return {
    columns: tableColumns,
    ...operation,
    exportOpts
  };
}